import { render, staticRenderFns } from "./blank.vue?vue&type=template&id=5d61e432&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "blank.vue"
export default component.exports